/**
 * D8 Directory vendor data
 * 47 authenticated and validated vendors
 * @module data/vendors
 */

import { Vendor, VendorMetricConfig } from '../types';

export const vendors: Vendor[] = [
  {
    rank: 1,
    name: "Colorado Botanicals",
    score: 9.35,
    product: 8.5,
    trust: 9.5,
    sentiment: 9.5,
    reputation: 9.5,
    market: 9.0,
    service: 9.5,
    summary: "A premier brand known for scientific rigor, product purity, and best-in-class customer service, specializing in high-quality CBD and CBG oils.",
    website: "https://www.coloradobotanicals.com/"
  },
  {
    rank: 2,
    name: "Lazarus Naturals",
    score: 9.28,
    product: 9.5,
    trust: 9.0,
    sentiment: 9.5,
    reputation: 9.0,
    market: 9.0,
    service: 9.5,
    summary: "A dominant, vertically integrated force offering a huge product range at accessible prices, with a renowned assistance program for veterans and low-income households.",
    website: "https://www.lazarusnaturals.com/"
  },
  {
    rank: 3,
    name: "Joy Organics",
    score: 9.15,
    product: 9.0,
    trust: 9.5,
    sentiment: 9.0,
    reputation: 9.5,
    market: 8.5,
    service: 9.5,
    summary: "A premium, family-owned brand focused on USDA Certified Organic products, transparency, and environmental responsibility, with exceptional customer care.",
    website: "https://joyorganics.com/"
  },
  {
    rank: 4,
    name: "3Chi",
    score: 8.95,
    product: 9.5,
    trust: 9.5,
    sentiment: 9.5,
    reputation: 9.0,
    market: 9.5,
    service: 6.5,
    summary: "A pioneering innovator in the Delta-8 and intoxicating cannabinoid market, lauded for potent, science-driven products but held back by a restrictive return policy.",
    website: "https://www.3chi.com/"
  },
  {
    rank: 5,
    name: "Secret Nature",
    score: 8.88,
    product: 9.0,
    trust: 9.0,
    sentiment: 9.5,
    reputation: 9.0,
    market: 8.5,
    service: 8.5,
    summary: "An artisan brand for the connoisseur, specializing in premium, indoor-grown CBD and THCa hemp flower with an authentic cannabis experience.",
    website: "https://secretnaturecbd.com/"
  },
  {
    rank: 6,
    name: "Horn Creek Hemp",
    score: 8.80,
    product: 8.5,
    trust: 9.0,
    sentiment: 9.5,
    reputation: 9.5,
    market: 7.5,
    service: 8.5,
    summary: "An award-winning, farm-direct producer from Oregon, celebrated for its high-quality CBD flower and exceptional transparency.",
    website: "https://horncreekhemp.com/"
  },
  {
    rank: 7,
    name: "Hometown Hero CBD",
    score: 8.78,
    product: 9.0,
    trust: 9.0,
    sentiment: 9.0,
    reputation: 9.5,
    market: 8.0,
    service: 8.5,
    summary: "A veteran-owned company with a powerful mission to support veterans, offering a diverse product line and leading industry advocacy efforts.",
    website: "https://hometownherocbd.com/"
  },
  {
    rank: 8,
    name: "Extract Labs",
    score: 8.75,
    product: 9.5,
    trust: 9.0,
    sentiment: 9.0,
    reputation: 8.5,
    market: 8.0,
    service: 8.5,
    summary: "A scientifically-grounded, cGMP-certified manufacturer known for its vast portfolio of minor cannabinoids and transparent batch testing.",
    website: "https://www.extractlabs.com/"
  },
  {
    rank: 9,
    name: "Charlotte's Web",
    score: 8.73,
    product: 8.5,
    trust: 9.0,
    sentiment: 9.0,
    reputation: 9.5,
    market: 9.0,
    service: 8.0,
    summary: "The iconic, original CBD brand that brought hemp to the mainstream, maintaining a legacy of trust and quality as a publicly traded company.",
    website: "https://www.charlottesweb.com/"
  },
  {
    rank: 10,
    name: "CBDistillery",
    score: 8.70,
    product: 9.5,
    trust: 9.0,
    sentiment: 8.5,
    reputation: 9.0,
    market: 8.5,
    service: 8.5,
    summary: "A trusted, high-value brand with one of the most extensive and high-potency product lines available, committed to education and transparency.",
    website: "https://www.thecbdistillery.com/"
  },
  {
    rank: 11,
    name: "Medterra",
    score: 8.65,
    product: 9.5,
    trust: 9.0,
    sentiment: 8.5,
    reputation: 8.5,
    market: 8.5,
    service: 8.5,
    summary: "Ranks highly due to an extensive product catalog covering all spectrums and a strong value proposition.",
    website: "https://medterracbd.com/"
  },
  {
    rank: 12,
    name: "NuLeaf Naturals",
    score: 8.60,
    product: 8.5,
    trust: 9.0,
    sentiment: 8.5,
    reputation: 9.0,
    market: 8.0,
    service: 8.5,
    summary: "A pioneering brand (est. 2014) with a strong reputation for quality, full-spectrum oils.",
    website: "https://nuleafnaturals.com/"
  },
  {
    rank: 13,
    name: "The Brothers Apothecary",
    score: 8.58,
    product: 8.0,
    trust: 9.0,
    sentiment: 9.5,
    reputation: 9.0,
    market: 7.0,
    service: 8.5,
    summary: "Scores exceptionally high on consumer sentiment for its unique and award-winning line of CBD teas.",
    website: "https://www.thebrothersapothecary.com/"
  },
  {
    rank: 14,
    name: "Aspen Green",
    score: 8.55,
    product: 8.0,
    trust: 9.5,
    sentiment: 9.0,
    reputation: 9.0,
    market: 7.5,
    service: 8.0,
    summary: "A premium, physician-formulated brand with a strong focus on USDA Organic certification.",
    website: "https://www.aspengreen.com/"
  },
  {
    rank: 15,
    name: "TRĒHouse",
    score: 8.48,
    product: 9.5,
    trust: 8.0,
    sentiment: 9.0,
    reputation: 8.0,
    market: 9.0,
    service: 8.0,
    summary: "A powerhouse in the intoxicating cannabinoid space with a broad and creative product line.",
    website: "https://trehouse.com/"
  },
  {
    rank: 16,
    name: "CBDfx",
    score: 8.45,
    product: 9.5,
    trust: 8.5,
    sentiment: 8.0,
    reputation: 8.5,
    market: 8.5,
    service: 8.5,
    summary: "Features a massive and diverse product catalog suitable for beginners and experienced users.",
    website: "https://cbdfx.com/"
  },
  {
    rank: 17,
    name: "Cheef Botanicals",
    score: 8.43,
    product: 9.5,
    trust: 8.5,
    sentiment: 8.5,
    reputation: 8.0,
    market: 8.0,
    service: 8.0,
    summary: "Offers a very broad product range, including many novel cannabinoids. Has a positive A+ BBB rating.",
    website: "https://cheefbotanicals.com/"
  },
  {
    rank: 18,
    name: "Canna River",
    score: 8.35,
    product: 8.5,
    trust: 8.5,
    sentiment: 9.0,
    reputation: 8.0,
    market: 7.5,
    service: 8.0,
    summary: "Strong positive consumer sentiment and a focus on affordability and sustainability.",
    website: "https://www.cannariver.com/"
  },
  {
    rank: 19,
    name: "Area 52",
    score: 8.33,
    product: 8.5,
    trust: 8.5,
    sentiment: 9.5,
    reputation: 8.0,
    market: 7.0,
    service: 7.5,
    summary: "Highly positive consumer reviews for its potent, well-formulated products and a generous guarantee.",
    website: "https://area52.com/"
  },
  {
    rank: 20,
    name: "Cornbread Hemp",
    score: 8.30,
    product: 8.0,
    trust: 8.5,
    sentiment: 8.5,
    reputation: 8.5,
    market: 7.5,
    service: 8.0,
    summary: "Strong brand story rooted in Kentucky hemp culture and a focus on USDA Organic, flower-only products.",
    website: "https://www.cornbreadhemp.com/"
  },
  {
    rank: 21,
    name: "FAB CBD",
    score: 8.28,
    product: 8.0,
    trust: 8.5,
    sentiment: 8.5,
    reputation: 8.5,
    market: 7.5,
    service: 8.0,
    summary: "A reputable brand with a solid product line and good reviews, but a more restrictive return policy.",
    website: "https://fabcbd.com/"
  },
  {
    rank: 22,
    name: "Koi CBD",
    score: 8.25,
    product: 9.0,
    trust: 8.0,
    sentiment: 8.5,
    reputation: 8.5,
    market: 8.0,
    service: 7.5,
    summary: "A long-standing brand (est. 2015) with a very diverse catalog but complex return and shipping policies.",
    website: "https://koicbd.com/"
  },
  {
    rank: 23,
    name: "PlusCBD",
    score: 8.23,
    product: 8.0,
    trust: 8.5,
    sentiment: 8.0,
    reputation: 8.5,
    market: 8.0,
    service: 8.0,
    summary: "A CV Sciences company with a long history and strong reputation; the first to achieve GRAS safety status.",
    website: "https://pluscbdoil.com/"
  },
  {
    rank: 24,
    name: "Moonwlkr",
    score: 8.18,
    product: 9.0,
    trust: 8.0,
    sentiment: 8.5,
    reputation: 7.5,
    market: 8.0,
    service: 8.0,
    summary: "Strong in the intoxicating cannabinoid space but with extensive shipping restrictions limiting its market reach.",
    website: "https://moonwlkr.com/"
  },
  {
    rank: 25,
    name: "Green Unicorn Farms",
    score: 8.15,
    product: 8.5,
    trust: 8.5,
    sentiment: 8.5,
    reputation: 7.5,
    market: 7.0,
    service: 8.0,
    summary: "A specialist in high-quality CBD and THCa flower with a strict, unopened-only return policy.",
    website: "https://greenunicornfarms.com/"
  },
  {
    rank: 26,
    name: "Budpop",
    score: 8.13,
    product: 9.0,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 7.5,
    market: 8.5,
    service: 8.0,
    summary: "Offers popular potent products, but its ranking is severely impacted by an 'F' rating on the BBB.",
    website: "https://budpop.com/"
  },
  {
    rank: 27,
    name: "Myriam's Hope Hemp",
    score: 8.05,
    product: 8.5,
    trust: 9.0,
    sentiment: 8.5,
    reputation: 8.0,
    market: 6.0,
    service: 7.0,
    summary: "A smaller, mission-driven brand with a strong focus on full-spectrum oils but a restrictive return policy.",
    website: "https://myriamshopehemp.com/"
  },
  {
    rank: 28,
    name: "Tweedle Farms",
    score: 8.03,
    product: 8.0,
    trust: 8.5,
    sentiment: 8.5,
    reputation: 8.0,
    market: 6.5,
    service: 7.5,
    summary: "A family-owned, farm-direct operation with a generous satisfaction guarantee but limited product range.",
    website: "https://tweedlefarms.com/"
  },
  {
    rank: 29,
    name: "Summit THC",
    score: 7.95,
    product: 7.5,
    trust: 8.5,
    sentiment: 8.5,
    reputation: 7.5,
    market: 7.0,
    service: 8.0,
    summary: "A focused brand specializing in gummies with positive reviews but a limited product format range.",
    website: "https://www.summitthc.com/"
  },
  {
    rank: 30,
    name: "Black Tie CBD",
    score: 7.90,
    product: 8.5,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 8.0,
    market: 7.5,
    service: 7.0,
    summary: "An award-winning brand for THCa flower, with mixed Trustpilot reviews and a nuanced return policy.",
    website: "https://blacktiecbd.net/"
  },
  {
    rank: 31,
    name: "Diet Smoke",
    score: 7.88,
    product: 8.0,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 7.0,
    market: 7.5,
    service: 8.0,
    summary: "Strong branding and a very consumer-friendly lifetime guarantee, but a less established brand history.",
    website: "https://www.dietsmoke.com/"
  },
  {
    rank: 32,
    name: "Exhale Wellness",
    score: 7.85,
    product: 9.5,
    trust: 8.5,
    sentiment: 8.5,
    reputation: 8.0,
    market: 9.0,
    service: 5.0,
    summary: "Huge product catalog and excellent return policy, but ranking is drastically lowered by an 'F' BBB rating.",
    website: "https://www.exhalewell.com/"
  },
  {
    rank: 33,
    name: "Elevate",
    score: 7.83,
    product: 9.0,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 7.5,
    market: 7.5,
    service: 7.5,
    summary: "Features a broad product line but a less established brand presence keeps it in the middle of the pack.",
    website: "https://www.elevateright.com/"
  },
  {
    rank: 34,
    name: "Delta Extrax",
    score: 7.75,
    product: 9.5,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 7.0,
    market: 8.5,
    service: 6.0,
    summary: "A major player with a vast, innovative catalog, but penalized by an 'F' BBB rating and unclear return policy.",
    website: "https://www.deltaextrax.com/"
  },
  {
    rank: 35,
    name: "CannaBuddy",
    score: 7.73,
    product: 9.5,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 7.0,
    market: 7.0,
    service: 7.0,
    summary: "An online dispensary with a huge catalog and A+ BBB rating, but lacks a clear return policy.",
    website: "https://www.cannabuddy.com/"
  },
  {
    rank: 36,
    name: "Diamond CBD",
    score: 7.65,
    product: 9.5,
    trust: 8.0,
    sentiment: 7.0,
    reputation: 8.0,
    market: 8.5,
    service: 6.5,
    summary: "A long-standing company with a massive product selection, but impacted by poor consumer sentiment on the BBB.",
    website: "https://www.diamondcbd.com/"
  },
  {
    rank: 37,
    name: "Wyld CBD",
    score: 7.60,
    product: 7.0,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 8.0,
    market: 7.5,
    service: 7.0,
    summary: "A market leader in gummies and beverages with excellent flavor, but a strict, uncompetitive return policy.",
    website: "https://wyldcbd.com/"
  },
  {
    rank: 38,
    name: "Hemp Bombs",
    score: 7.58,
    product: 8.0,
    trust: 8.0,
    sentiment: 7.5,
    reputation: 8.0,
    market: 7.5,
    service: 7.0,
    summary: "A large manufacturer with a solid product range, but lacks a clearly defined, generous return policy.",
    website: "https://hempbombs.com/"
  },
  {
    rank: 39,
    name: "Delta 8 THC Austin",
    score: 7.55,
    product: 9.5,
    trust: 8.0,
    sentiment: 7.5,
    reputation: 7.0,
    market: 6.5,
    service: 7.0,
    summary: "A retailer with a large product catalog but a restrictive return policy that excludes most products.",
    website: "https://delta8thcaustin.com/"
  },
  {
    rank: 40,
    name: "Neurogan",
    score: 7.53,
    product: 8.5,
    trust: 8.5,
    sentiment: 7.0,
    reputation: 8.0,
    market: 7.0,
    service: 7.0,
    summary: "A family-owned brand with high-potency options, but a limited money-back guarantee.",
    website: "https://www.neurogan.com/"
  },
  {
    rank: 41,
    name: "Binoid",
    score: 7.48,
    product: 10.0,
    trust: 8.0,
    sentiment: 7.5,
    reputation: 7.5,
    market: 9.0,
    service: 4.0,
    summary: "Features arguably the most extensive product catalog, but ranks near the bottom due to an abysmal customer service record.",
    website: "https://www.binoidcbd.com/"
  },
  {
    rank: 42,
    name: "Medical Mike's",
    score: 7.45,
    product: 7.0,
    trust: 8.5,
    sentiment: 8.0,
    reputation: 7.5,
    market: 6.0,
    service: 7.0,
    summary: "A farm-direct brand with high-quality organic products, limited by a small product line and strict return policy.",
    website: "https://medicalmikes.com/"
  },
  {
    rank: 43,
    name: "USA Medical",
    score: 7.40,
    product: 7.0,
    trust: 8.0,
    sentiment: 8.0,
    reputation: 7.0,
    market: 6.0,
    service: 7.5,
    summary: "A focused brand with a clear product strategy, but lacks a clearly stated return policy on its website.",
    website: "https://usamedical.com/"
  },
  {
    rank: 44,
    name: "Modus",
    score: 7.38,
    product: 8.5,
    trust: 7.5,
    sentiment: 8.0,
    reputation: 7.0,
    market: 7.0,
    service: 6.5,
    summary: "A brand with a wide array of intoxicating cannabinoid blends, but lacks an accessible and generous return policy.",
    website: "https://modusbrand.com/"
  },
  {
    rank: 45,
    name: "Hollyweed",
    score: 7.35,
    product: 8.0,
    trust: 7.5,
    sentiment: 7.5,
    reputation: 7.0,
    market: 7.0,
    service: 7.0,
    summary: "Offers a decent range of popular products, but the absence of clear policies lowers its trust score.",
    website: "https://hollyweedcbd.com/"
  },
  {
    rank: 46,
    name: "Leafy8",
    score: 7.25,
    product: 8.0,
    trust: 7.5,
    sentiment: 7.5,
    reputation: 7.0,
    market: 6.5,
    service: 6.0,
    summary: "Ranks low due to an extremely restrictive 'All Purchases Are Final & Non-Refundable' policy.",
    website: "https://leafy8.com/"
  },
  {
    rank: 47,
    name: "Botany Farms",
    score: 6.95,
    product: 8.5,
    trust: 8.0,
    sentiment: 7.0,
    reputation: 7.0,
    market: 6.5,
    service: 4.0,
    summary: "Despite a good product line, its 'All Sales Are Final' policy is a critical failure in customer service.",
    website: "https://www.botanyfarms.com/"
  }
];

export const metricConfigs: VendorMetricConfig[] = [
  { key: 'product', label: 'Product Catalog', colorClass: 'bg-blue-500' },
  { key: 'trust', label: 'Trust & Transparency', colorClass: 'bg-teal-500' },
  { key: 'sentiment', label: 'Consumer Sentiment', colorClass: 'bg-purple-500' },
  { key: 'service', label: 'Customer Service', colorClass: 'bg-yellow-500' },
  { key: 'reputation', label: 'Brand Reputation', colorClass: 'bg-pink-500' },
  { key: 'market', label: 'Market Share', colorClass: 'bg-red-500' }
];
